var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFondsdepot = function SvgFondsdepot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fondsdepot_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.6 75.76",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fondsdepot_svg__clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-1",
    d: "M0 0h161.6v52.1H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".fondsdepot_svg__cls-1{fill:none}.fondsdepot_svg__cls-3,.fondsdepot_svg__cls-4{fill:#000}"))), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-4",
    d: "M81.4 0H0v21.4h3.3V3.2h78.1V0z",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-4",
    d: "M158.1 21.3v16.3H84.8v3.2h76.7V21.3h-3.4z",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M25.8 17.4V14H15.2v15.5h3.9v-6h5.7v-3.4h-5.7v-2.7h6.7z",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M39.7 21.7c0-2.3.1-4.5-1.6-6.1-1.1-1.1-2.5-1.7-4.4-1.7s-3.2.6-4.4 1.7c-1.6 1.6-1.6 3.8-1.6 6.1s-.1 4.5 1.6 6.1c1.1 1.1 2.5 1.7 4.4 1.7s3.2-.6 4.4-1.7c1.6-1.6 1.6-3.8 1.6-6.1m-3.9 0c0 2.8-.2 3.3-.6 3.8-.3.4-.8.7-1.5.7s-1.2-.3-1.5-.7c-.4-.5-.6-1-.6-3.8s.2-3.3.6-3.8c.3-.4.8-.7 1.5-.7s1.2.3 1.5.7c.4.5.6 1 .6 3.8",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M54.3 29.5V14h-3.9v7.8l-5-7.8h-3.3v15.5h3.8v-7.8l5 7.8h3.4z",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M69 21.7c0-2.4.2-4.4-1.6-6.2-1.1-1.1-2.6-1.5-4.2-1.5h-5.8v15.5h5.8c1.6 0 3.1-.5 4.2-1.5 1.8-1.9 1.6-3.8 1.6-6.3m-3.9 0c0 2.6-.1 3-.4 3.5-.4.5-.9.9-1.8.9h-1.7v-8.7h1.7c1 0 1.5.3 1.8.9.3.4.4.8.4 3.4",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M81.9 24.7c0-1.4-.3-2.6-1.2-3.4-.7-.7-1.7-1.1-3.1-1.3l-1.9-.3c-.5-.1-.9-.3-1.1-.5s-.3-.5-.3-.7c0-.7.5-1.4 1.9-1.4.7 0 2-.1 3 .9l2.4-2.4c-1.3-1.3-3-1.8-5.3-1.8-3.6 0-5.7 2.1-5.7 4.9 0 1.3.4 2.4 1.1 3.1s1.8 1.2 3.1 1.4l1.9.3c.5.1.8.2 1 .4.2.2.3.5.3.9 0 .9-.7 1.4-2.2 1.4-1.2 0-2.7-.3-3.5-1.1l-2.4 2.4c1.6 1.6 3.5 2 5.9 2 3.3.1 6.1-1.6 6.1-4.8",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M95.7 21.6c0-2.2.1-4.5-1.6-6.2-1-1-2.4-1.5-4-1.5h-5.5v15.6h5.5c1.6 0 3-.5 4-1.5 1.7-1.7 1.6-4.1 1.6-6.4m-2.3 0c0 2.1 0 3.8-.8 4.7-.7.7-1.5 1-2.7 1H87V16.1h2.9c1.1 0 2 .3 2.7 1 .7.9.8 2.4.8 4.5",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M109.2 29.5v-2.1h-7.6v-4.7h6.5v-2.1h-6.5v-4.5h7.6V14h-10v15.5h10z",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M123.1 18.7c0-2.7-1.9-4.7-5-4.7h-5.9v15.5h2.4v-6.1h3.5c3.1 0 5-2 5-4.7m-2.3 0c0 1.6-1.1 2.6-2.8 2.6h-3.4v-5.2h3.4c1.7 0 2.8.9 2.8 2.6",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M136.4 21.7c0-3 0-4.7-1.5-6.2-1.1-1.1-2.5-1.7-4.1-1.7-1.7 0-3 .6-4.1 1.7-1.5 1.5-1.5 3.2-1.5 6.2s0 4.7 1.5 6.2c1.1 1.1 2.4 1.7 4.1 1.7s3-.6 4.1-1.7c1.6-1.5 1.5-3.2 1.5-6.2m-2.3 0c0 3.1-.2 4-.9 4.8-.5.6-1.4 1-2.3 1s-1.8-.4-2.3-1c-.8-.8-.9-1.7-.9-4.8s.2-4 .9-4.8c.5-.6 1.4-1 2.3-1s1.8.4 2.3 1c.7.8.9 1.7.9 4.8",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M149.3 16.1V14h-10.9v2.1h4.3v13.4h2.3V16.1h4.3z",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M26.3 47.9c0-2-1.2-2.7-1.8-3.1.5-.3 1.6-1.2 1.6-2.8 0-2.4-1.6-4.1-4.7-4.1h-6.2v14h6.5c2.6.2 4.6-1.3 4.6-4m-3.9-5.6c0 .6-.3 1.1-1.3 1.1h-2.3v-2.3h2.3c1 .1 1.3.6 1.3 1.2m.3 5.5c0 .6-.3 1.2-1.3 1.2h-2.5v-2.5h2.5c.9 0 1.3.7 1.3 1.3",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "m44.9 52.1-5.4-14h-2.8l-5.4 14h3.8l.7-2.1h4.6l.7 2.1h3.8Zm-5.4-5h-2.6l1.3-3.7 1.3 3.7Z",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "M62 52.1v-14h-3.6v7l-4.8-7h-3.2v14h3.7V45l4.7 7.1H62z",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fondsdepot_svg__cls-3",
    d: "m81.6 52.1-5.3-8.4 5.1-5.6h-4.5L72.6 43v-4.9H69v14h3.6v-4.4l1.3-1.4 3.4 5.8h4.3z",
    style: {
      clipPath: "url(#fondsdepot_svg__clippath-15)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.53 67.49c.1-1.07 1-2.1 3.03-2.1s3.03.83 3.03 2.76v5h-.99v-1.02c-.44.58-1.39 1.23-2.63 1.23-1.52 0-2.81-.8-2.81-2.39 0-1.31.81-2.21 2.67-2.39l2.77-.29v-.15c0-1.16-.45-1.92-2.05-1.92-1.39 0-1.9.54-2.03 1.26h-1Zm5.08 2.39v-.8l-2.63.29c-1.31.15-1.83.65-1.83 1.6 0 1.1.88 1.55 1.9 1.55 1.38 0 2.55-.96 2.55-2.64ZM24.78 66.62c.49-.81 1.38-1.23 2.47-1.23 1.65 0 2.65.94 2.65 2.76v5h-.99v-4.86c0-1.39-.58-2.06-1.89-2.06-1.16 0-2.25.81-2.25 2.5v4.42h-.99v-7.54h.99v1.02ZM35.82 62.99h7.4v1.6h-5.51v2.68h5.22v1.6h-5.22v4.28h-1.89V63ZM51.91 62.99h1.89v10.15h-2.03l-3.05-4.42c-1.1-1.6-1.57-2.39-1.93-3.05h-.06c.07.94.1 1.6.1 3.19v4.28h-1.89V62.99h2.03l3.05 4.42c1.1 1.6 1.57 2.39 1.93 3.05h.06c-.07-.94-.1-1.6-.1-3.19v-4.28ZM63.52 73.15h-7.98v-1.6l5.44-6.96h-5.29v-1.6h7.62v1.6l-5.44 6.96h5.66v1.6ZM74.89 71.11c-.45 1.35-1.52 2.25-3.19 2.25-2.32 0-3.68-1.74-3.68-3.99s1.36-3.99 3.68-3.99c1.61 0 2.66.84 3.12 2.1h-1.06c-.35-.77-1.03-1.26-2.06-1.26-1.68 0-2.7 1.34-2.7 3.15s1.02 3.15 2.7 3.15c1.07 0 1.78-.54 2.15-1.41h1.04ZM79.75 73.36c-2.25 0-3.76-1.74-3.76-3.99s1.51-3.99 3.76-3.99 3.76 1.74 3.76 3.99-1.51 3.99-3.76 3.99Zm0-.84c1.61 0 2.77-1.34 2.77-3.15s-1.16-3.15-2.77-3.15-2.77 1.34-2.77 3.15 1.16 3.15 2.77 3.15ZM86.28 66.54c.44-.8 1.39-1.16 2.19-1.16 1.07 0 1.96.46 2.39 1.38.36-.8 1.31-1.38 2.47-1.38 1.6 0 2.67.94 2.67 2.76v5h-.99v-4.86c0-1.38-.58-2.13-1.83-2.13-.96 0-2.05.68-2.05 2.35v4.64h-.99v-4.86c0-1.38-.58-2.13-1.83-2.13-.96 0-2.05.68-2.05 2.35v4.64h-.99V65.6h.99v.94ZM99.2 66.69c.44-.73 1.39-1.31 2.63-1.31 2.25 0 3.39 1.81 3.39 3.99s-1.15 3.99-3.39 3.99c-1.23 0-2.19-.58-2.63-1.31v3.7h-.99V65.6h.99v1.09Zm2.48 5.83c1.83 0 2.55-1.55 2.55-3.15s-.73-3.15-2.55-3.15-2.55 1.63-2.55 3.15.73 3.15 2.55 3.15ZM106.86 67.49c.1-1.07 1-2.1 3.03-2.1s3.03.83 3.03 2.76v5h-.99v-1.02c-.44.58-1.39 1.23-2.63 1.23-1.52 0-2.81-.8-2.81-2.39 0-1.31.81-2.21 2.67-2.39l2.77-.29v-.15c0-1.16-.45-1.92-2.05-1.92-1.39 0-1.9.54-2.03 1.26h-1Zm5.08 2.39v-.8l-2.63.29c-1.31.15-1.83.65-1.83 1.6 0 1.1.88 1.55 1.9 1.55 1.38 0 2.55-.96 2.55-2.64ZM116.11 66.62c.49-.81 1.38-1.23 2.47-1.23 1.65 0 2.65.94 2.65 2.76v5h-.99v-4.86c0-1.39-.58-2.06-1.89-2.06-1.16 0-2.25.81-2.25 2.5v4.42h-.99v-7.54h.99v1.02ZM125.36 73.15l-2.84-7.54h1.06l1.39 3.8c.32.87.64 1.87.83 2.54h.06c.2-.67.57-1.65.89-2.52l1.41-3.82h1.02l-3.08 8.28c-.42 1.15-1 1.87-2.67 1.87h-.61v-.84h.61c.97 0 1.38-.25 1.78-1.34l.16-.44Z"
  })));
};

export default SvgFondsdepot;